import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'appHooks'
import { DocumentArchiveTab } from './shared/enums'

type Filter = {
  activeTab: DocumentArchiveTab
}

const initialState: Filter = {
  activeTab: DocumentArchiveTab.Board,
}

const documentArchiveSlice = createSlice({
  name: 'documentArchive',
  initialState,
  reducers: {
    setDocumentArchiveActiveTab: (
      state,
      action: PayloadAction<DocumentArchiveTab>
    ) => {
      state.activeTab = action.payload
    },
  },
})

export const { setDocumentArchiveActiveTab } = documentArchiveSlice.actions

export default documentArchiveSlice

export const getDocumentArchiveActiveTab = (state: RootState) =>
  state.documentArchive.activeTab
